module.exports = __webpack_public_path__ + "img/green-plus.e69f1a62.svg";